import { render, staticRenderFns } from "./UpdateHomeworkTimeDialog.vue?vue&type=template&id=40e3b008"
import script from "./UpdateHomeworkTimeDialog.vue?vue&type=script&lang=js"
export * from "./UpdateHomeworkTimeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports